export default __webpack_public_path__ + "static/contactDesktop-203918565846853ed4c5fdbe7b875d5a.webp";